module.exports = __webpack_public_path__ + "img/Schnitt längs.860f3664.jpg";